import { Assistance } from "./assistance";

export class AssistanceBlock {
    username: string;
    courseId: string;
    date: string;
    timeBlockId: string;
    assistance: Assistance[] = [];

}